import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { MissionPageContainer } from "../../common_components/Layout";
import SubHeader from "../SubHeader";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";

import { Card, GrayCardTitle } from "../../common_components/Layout";


// Api Calls
import PricingAPI from "../../../api/api_calls/PricingAPI";


function PricingPage(props) {
    // So we'll 
    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [loadingPricing, setLoadingPricing] = useState(true);

    const [currentPrice, setCurrentPrice] = useState({});
    const [pricingHistory, setPricingHistory] = useState({});
    const [paymentMethod, setPaymentMethod] = useState({});
    const [totalAmount, setTotalAmount] = useState({});
    const [responseCount, setResponseCount] = useState({});
    const [paymentMethodType, setPaymentMethodType] = useState({});


    useEffect(() => {
        async function getPricingDetails() {
            const result = await PricingAPI.index({ missionId, handleRedirect: navigate });

            if (result.success) {
                setCurrentPrice(result.current_price)
                setPricingHistory(result.pricing_history)
                setPaymentMethod(result.payment_method)
                setTotalAmount(result.total_amount)
                setResponseCount(result.response_count)
                setPaymentMethodType(result.payment_method_type)
                setLoadingPricing(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }
        getPricingDetails();
    }, []);




    return (
        <>
            <SubHeader title={"Pricing"} backText="Back to Project" navigateBack={() => navigate("/missions/" + missionId)} />
            <MissionPageContainer>
                {loadingPricing ?
                    <CenteredLoadingIcon />
                    :
                    <>
                        <div className="horizontal-card-container">

                            <CurrentPricingCard currentPrice={currentPrice} totalAmount={totalAmount} responseCount={responseCount} loading={loadingPricing} />
                            <PaymentMethodCard paymentMethod={paymentMethod} paymentMethodType={paymentMethodType} loading={loadingPricing} />
                        </div>
                        <PastSessionPriceCard pricingHistory={pricingHistory} loading={loadingPricing} />
                    </>}
            </MissionPageContainer>
        </>

    )

}


function CurrentPricingCard(props) {
    return (
        <Card style={{ flexGrow: 1, width: "100%" }} >
            <GrayCardTitle title="Current Pricing" />
            {props.loading ? <CenteredLoadingIcon /> :
                <>
                    <div className="editable-field">

                        <div className="editable-field-title">
                            Current Price per Session
                        </div>
                        <div className="editable-field-value">

                            <div className="editable-field-value-text">
                                ${props.currentPrice}
                            </div>
                        </div>
                    </div>
                    <div className="editable-field">
                        <div className="editable-field-title">
                            Total Sessions Completed
                        </div>
                        <div className="editable-field-value">

                            <div className="editable-field-value-text">
                                {props.responseCount}
                            </div>
                        </div>
                    </div>
                    <div className="editable-field">

                        <div className="editable-field-title">
                            Total Price (based on completed sessions so far)
                        </div>
                        <div className="editable-field-value">

                            <div className="editable-field-value-text">
                                ${props.totalAmount}
                            </div>
                        </div>
                    </div>
                </>
            }
        </Card>
    )
}

function PastSessionPriceCard(props) {
    // Sort by mission_price_quote_id descending (most recent first)
    const sortedHistory = props.pricingHistory ? [...props.pricingHistory].sort((a, b) =>
        b.mission_price_quote_id - a.mission_price_quote_id
    ) : [];

    return (
        <Card>
            <GrayCardTitle title="Completed Sessions Pricing" />
            {props.loading ? <CenteredLoadingIcon /> :
                sortedHistory.length === 0 ? (
                    <div className="pricing-empty-state">
                        No completed sessions yet
                    </div>
                ) : (
                    <div className="pricing-table-container">
                        <table className="pricing-table">
                            <thead>
                                <tr className="pricing-table-header">
                                    <th className="pricing-table-header-cell">Session Type</th>
                                    <th className="pricing-table-header-cell">Quantity</th>
                                    <th className="pricing-table-header-cell">Price per Session</th>
                                    <th className="pricing-table-header-cell pricing-table-header-cell--right">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedHistory.map((item) => (
                                    <tr
                                        key={item.mission_price_quote_id}
                                        className="pricing-table-row white-text"
                                    >
                                        <td className="pricing-table-cell">{item.name}</td>
                                        <td className="pricing-table-cell">{item.quantity}</td>
                                        <td className="pricing-table-cell">${item.price}</td>
                                        <td className="pricing-table-cell pricing-table-cell--right">${item.total}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="pricing-table-note">
                            Multiple rows indicate that the mission was changed after launch. Each row represents a different price quote. The price may not have changed for all rows.
                        </div>
                    </div>
                )
            }
        </Card>
    )
}

function PaymentMethodCard(props) {


    function DisplayPaymentMethod() {
        if (props.paymentMethodType === "stripe") {
            return <StripePaymentMethod />
        } else if (props.paymentMethodType === "crypto") {
            return <CryptoPaymentMethod />
        } else if (props.paymentMethodType === "invoice") {
            return <InvoicePaymentMethod />
        } else {
            return <NonePaymentMethod />
        }
    }

    function StripePaymentMethod() {
        return (
            <>
                <div className="card-summary card-summary--dark" role="group" aria-label="Saved payment method">
                    {/* Optional: brand logo, e.g. based on `brand` */}
                    <div className="card-summary__icon">
                        {/* Put an <img> or SVG here if you want */}
                        <span className="card-summary__brand-initials">
                            {props.paymentMethod.brand[0]?.toUpperCase()}
                        </span>
                    </div>

                    <div className="card-summary__content">
                        <div className="card-summary__row">
                            <span className="card-summary__brand">
                                {props.paymentMethod.brand} •••• {props.paymentMethod.last4}
                            </span>
                        </div>
                        <span className="card-summary__meta">
                            Expires {props.paymentMethod.exp_month}/{props.paymentMethod.exp_year}
                        </span>
                    </div>
                </div>

            </>
        )
    }

    function CryptoPaymentMethod() {
        return (
            <div className="card-summary card-summary--dark" role="group" aria-label="Crypto payment method">
                <div className="card-summary__icon">
                    <span className="card-summary__brand-initials">
                        {props.paymentMethod.blockchain?.[0]?.toUpperCase() || 'C'}
                    </span>
                </div>

                <div className="card-summary__content">
                    <div className="card-summary__row">
                        <span className="card-summary__brand">
                            {props.paymentMethod.blockchain}
                        </span>
                    </div>
                    <div className="payment-method-detail">
                        <span className="payment-method-detail__label">Wallet Address:</span>
                        <span className="payment-method-detail__value">{props.paymentMethod.wallet_address}</span>
                    </div>
                    {props.paymentMethod.company_country && (
                        <div className="payment-method-detail">
                            <span className="payment-method-detail__label">Country:</span>
                            <span className="payment-method-detail__value">{props.paymentMethod.company_country}</span>
                        </div>
                    )}
                    {props.paymentMethod.company_address && (
                        <div className="payment-method-detail">
                            <span className="payment-method-detail__label">Address:</span>
                            <span className="payment-method-detail__value">{props.paymentMethod.company_address}</span>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    function InvoicePaymentMethod() {
        return (
            <div className="card-summary card-summary--dark" role="group" aria-label="Invoice payment method">
                <div className="card-summary__icon">
                    <span className="card-summary__brand-initials">
                        I
                    </span>
                </div>

                <div className="card-summary__content">
                    <div className="card-summary__row">
                        <span className="card-summary__brand">
                            Invoice Payment
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    function NonePaymentMethod() {
        return (
            <div>
                <div className="white-text">
                    None listed
                </div>
            </div>
        )
    }


    return (
        <Card style={{ flexGrow: 1, width: "100%" }} >
            <GrayCardTitle title="Payment Method" />
            {props.loading ? <CenteredLoadingIcon /> :
                <>
                    <DisplayPaymentMethod />
                    <div className="pricing-table-note no-margin-top">
                        Need to change? Contact us at info@despark.io
                    </div>
                </>
            }
        </Card>
    )

}

export default PricingPage;